import React, { useEffect, useState } from 'react';
import ModuleEditBlock from '../Block';
import { useMessageManagerProvider } from '../../../../../../../../context/messageManager';
import QuillRichTextEditor from '../../../../../../../Common/QuillRichTextEditor';

function TextBlock({ tab }: { tab: number }) {
  const { selectedModule, handleSelectedModule, state, handleDispatch } = useMessageManagerProvider();
  const { endOfStatement } = state.step2;
  const isEos = tab === 1;

  const sourceValue = isEos
    ? endOfStatement.selected?.content?.[0] || ''
    : selectedModule?.item?.content[selectedModule?.textTabIndex || 0] || '';

  const [currentValue, setCurrentValue] = useState<string>(sourceValue);

  useEffect(() => {
    setCurrentValue(sourceValue);
  }, [isEos, endOfStatement.selected?.id, selectedModule?.item?.id, selectedModule?.textTabIndex]);

  const handleTextEditor = (value: string) => {
    setCurrentValue(value);

    if (isEos && endOfStatement.selected) {
      handleDispatch({
        step2: {
          ...state.step2,
          endOfStatement: {
            ...endOfStatement,
            selected: {
              ...endOfStatement.selected,
              content: [value],
            },
          },
        },
      });

      return;
    }

    if (selectedModule?.item?.id) {
      handleSelectedModule({
        ...selectedModule,
        item: {
          ...selectedModule.item,
          content: selectedModule.item.content.map((el, index) => (index === selectedModule.textTabIndex ? value : el)),
        },
      });
    }
  };

  const showEditor = isEos ? Boolean(endOfStatement.selected) : selectedModule?.textTabIndex !== undefined;

  return (
    <ModuleEditBlock title="Text" subTitle="">
      <div className="flex gap-[20px] items-start">
        {showEditor ? <QuillRichTextEditor onChange={handleTextEditor} value={currentValue} /> : null}
      </div>
    </ModuleEditBlock>
  );
}

export default TextBlock;
